
import { Vue, Component, Ref } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import uploadModal from '@/views/workbenches/subassembly/uploadModal.vue';
import moment from 'moment';

@Component({
  components: {
    uploadModal,
  },
})
export default class TargetConsumptionManagement extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  refresh() {
  }
  @Ref('importModal')
  importModal: any;

  moment = moment;

  uploadUrl = {
    url: '/wb/ad/upload_target',
    month: '',
    downUrl: '/wb/performance/download?dept_id=4',
    type: 'PromotionCompletion',
    title: '推广通消耗目标',
  };
  filterForm: any = {
    month: '',
  };

  form: any = {
    year: '',
    yearAll: '',
    data: '',
  };
  allConsumption: any = 0;
  yearList = [
    '2025',
    '2026',
    '2027',
    '2028',
    '2029',
    '2030',
    '2031',
    '2032',
    '2033',
    '2034',
    '2035',
    '2036',
    '2037',
  ];
  columns: any = [];
  dataList: any = [];
  templateList: any = [];
  old_query: any = '';

  uploadModal() {
    this.importModal.init(this.uploadUrl);
  }
  formatNumberWithCommas(num: number): string {
    return new Intl.NumberFormat().format(num);
  }

  changeUploaMonth(val: any) {
    const year = val._d.getFullYear(); // 获取当前年份，例如：2021
    let month: any = Number(val._d.getMonth()) + 1; // 获取当前月份，注意需要加1，例如：9
    if (month < 10) {
      month = `0${month}`;
    }
    this.uploadUrl.month = `${year}-${month}`;
    this.uploadUrl.url = `${this.uploadUrl.url}?month=${this.uploadUrl.month}`;
  }
  back() {
    if (this.old_query) {
      this.$router.push({
        name: 'workbenches.PromotionCompletionRate',
        query: {
          ...this.old_query,
        },
      });
    } else {
      this.$router.push({
        name: 'workbenches.index',
      });
    }
  }
  async handleClickSave() {
    const consumptionList: any = [];
    this.dataList.forEach((item: any) => {
      for (const key in item) {
        if (key.includes('dept_')) {
          consumptionList.push({
            dept_id: key.split('_')[1],
            target_time: item.year,
            target_quota: item[key],
          });
        }
      }
    });
    if (Number(this.form.yearAll) === 0) {
      this.$message.error('年度消耗目标总额不能为0');
      return;
    }
    if (Number(this.form.yearAll) > this.allConsumption) {
      this.$message.error('总合计不能低于年度消耗目标总额');
      return;
    }
    this.form.data = consumptionList;
    const res = await this.workbenchesService.postAdTargetManageEdit(this.form);
    if (res) {
      this.$message.success('保存成功');
      this.getAdTargetManage(this.form.year);
    }
  }
  handleBlur(event: any, record: any, _id: any) {
    const _record: any = { ...record };
    _record[_id] = event || 0;
    _record.sum = 0;
    for (const key in _record) {
      if (key.includes('dept_')) {
        _record.sum += Number(_record[key]);
      }
    }
    const _index = this.dataList.findIndex((item: any) => item.year === _record.year);
    this.dataList[_index] = _record;
    this.funAllConsumption();
  }
  funAllConsumption() {
    this.allConsumption = this.dataList.reduce((acc: any, curr: any) => Number(acc) + Number(curr.sum), 0);
  }

  handleChangeYear(year: any) {
    this.getAdTargetManage(year);
  }
  mounted() {
    const data = new Date();
    const year = data.getFullYear() + 1;
    this.getAdTargetManage(year);
    const { old_query } = this.$route.query;
    if (old_query) {
      this.old_query = JSON.parse(old_query as string);
    }
  }

  async getAdTargetManage(year: any) {
    const res = await this.workbenchesService.getAdTargetManage({ year });
    this.form.year = res.year;
    this.form.yearAll = res.yearAll;
    // this.form.data = res.data;
    this.getConsumption(res);
  }


  getConsumption(allData: any) {
    // const allData: any = {
    //   dept: {
    //     35: {
    //       id: 35,
    //       dept_name: '运营品牌部',
    //     },
    //     36: {
    //       id: 36,
    //       dept_name: '运营一部',
    //     },
    //     40: {
    //       id: 40,
    //       dept_name: '运营二部',
    //     },
    //     41: {
    //       id: 41,
    //       dept_name: '运营三部',
    //     },
    //     42: {
    //       id: 42,
    //       dept_name: '运营四部',
    //     },
    //   },
    //   month: [
    //     {
    //       year: 2025,
    //       month: '04',
    //       date: '2025-04-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '05',
    //       date: '2025-05-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '06',
    //       date: '2025-06-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '07',
    //       date: '2025-07-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '08',
    //       date: '2025-08-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '09',
    //       date: '2025-09-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '10',
    //       date: '2025-10-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '11',
    //       date: '2025-11-01',
    //     },
    //     {
    //       year: 2025,
    //       month: '12',
    //       date: '2025-12-01',
    //     },
    //     {
    //       year: 2026,
    //       month: '01',
    //       date: '2026-01-01',
    //     },
    //     {
    //       year: 2026,
    //       month: '02',
    //       date: '2026-02-01',
    //     },
    //     {
    //       year: 2026,
    //       month: '03',
    //       date: '2026-03-01',
    //     },
    //   ],
    //   year: '2025',
    //   data: [
    //     {
    //       dept_id: 42,
    //       target_quota: '200.00',
    //       target_time: '2025-06-01',
    //     },
    //   ],
    //   yearAll: 0,
    // };

    const { month, dept, data } = allData;
    const consumptionList: any = [];
    const columnsList: any = [
      {
        title: '月份',
        dataIndex: 'year',
      },
      {
        title: '合计',
        dataIndex: 'sum',
        scopedSlots: { customRender: 'sum' },
        width: 100,
      },
    ];
    const templateList: any = [];
    for (const key in dept) {
      if (key) {
        const _id = `dept_${dept[key].id}`;
        const h = this.$createElement;
        columnsList.push({
          title: dept[key].dept_name,
          dataIndex: _id,
          scopedSlots: { customRender: 'dept_id' },
          customRender: (text: any, record: any) => {
            return h('a-input', {
              attrs: {
                value: record[_id],
                type: 'number',
              },
              on: {
                blur: (e: any) => this.handleBlur(e.target.value, record, _id),
              },
            });
          },
        });
        templateList.push(_id);
      }
    }
    month.forEach((item: any) => {
      const _i = item;
      let _obj: any = {
        year: `${_i.year}-${_i.month}`,
        sum: 0,
      };
      for (const key in dept) {
        if (key) {
          const _id = `dept_${dept[key].id}`;
          _obj = Object.assign({}, _obj, { [_id]: 0 });
        }
      }
      consumptionList.push(_obj);
    });
    data.forEach((_item: any) => {
      const _i = _item;
      const _id = `dept_${_i.dept_id}`;
      for (const i in consumptionList) {
        if (_item.target_time.includes(consumptionList[i].year)) {
          consumptionList[i][_id] = _i.target_quota;
          consumptionList[i].sum = 0;
          for (const key in consumptionList[i]) {
            if (key.includes('dept_')) {
              consumptionList[i].sum += Number(consumptionList[i][key]);
            }
          }
        }
      }
    });
    const sum = consumptionList.reduce((acc: any, curr: any) => Number(acc) + Number(curr.sum), 0);
    this.allConsumption = sum;
    this.columns = columnsList;
    this.dataList = consumptionList;
    this.templateList = templateList;
  }
}
